import InstallOrderBaseModal from './install-order-base-modal.vue'
export default InstallOrderBaseModal
